export default {
  namespaced: true,
  state: {
    adminRoles: []
  },
  getters: {
    ADMIN_ROLES: state => {
      return state.adminRoles
    }
  },
  mutations: {
    SET_CURRENT_USER_ADMIN_ROLES(state, payload) {
      state.adminRoles = payload
    }
  },
  actions: {
    async getMyAdminRoles({ commit }, newValue) {
      commit('SET_CURRENT_USER_ADMIN_ROLES', newValue)
    }
  }
}
